// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2zKav","actionsCol":"EnrolledClinics_actionsCol__11qB7"};